import React from 'react';
import Card from './AppointmentCardStyles';

import userIcon from '../../images/common/user-icon.svg';
import hashIcon from '../../images/hash.svg';
import doctorIcon from '../../images/common/doctor-icon.svg';
import currencyIcon from '../../images/common/currency-icon.svg'
import centerBuildingIcon from '../../images/center-building.svg';
import calendarIcon from '../../images/common/calendar-icon.svg'


const PARAMS = [
    { name: 'Patient', valueKey: 'patientName', icon: userIcon },
    { name: 'Consultation ID', valueKey: 'requestId', icon: hashIcon },
    { name: 'Doctor', valueKey: 'doctorName', icon: doctorIcon },
    { name: 'Consultation Fee', valueKey: 'doctorOpdCharge', icon: currencyIcon },
    { name: 'Center Details', valueKey: 'centerName', icon: centerBuildingIcon },
    { name: 'Consultation Date & Time', valueKey: 'appointmentOn', icon: calendarIcon },
];

const ReusableCard = ({
    cardParams = PARAMS,
    requestDetails: props,
    tagName
}) => {

    return <Card.BorderedBody>
        {tagName ? <Card.AbsoluteTag>{tagName}</Card.AbsoluteTag> : <></>}
        {cardParams.map((item) => <React.Fragment key={item.name}>
            <Card.DataRow className='mb-10'>
                <Card.DataIconContainer>
                    <Card.DataIcon src={item.icon} alt={item.name} />
                </Card.DataIconContainer>
                <Card.DataColumn>
                    <Card.DataTextContainer>
                        <Card.DataTextSubtitle> {item.name} </Card.DataTextSubtitle>
                        <Card.DataTextSubContainer>

                            <Card.DataTextHeading>

                                {props[item.valueKey]}

                            </Card.DataTextHeading>

                        </Card.DataTextSubContainer>
                    </Card.DataTextContainer>
                </Card.DataColumn>
            </Card.DataRow>
        </React.Fragment>)}

    </Card.BorderedBody>
};

export default ReusableCard;